import { styled } from "goober";

export const TypeIconFrame = styled("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--size, var(--sp-7));
  width: var(--size, var(--sp-7));

  svg,
  img {
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: var(--size);
    height: var(--size);
  }

  > svg:first-child,
  > img:first-child {
    height: var(--size, 80%) !important;
    width: var(--size, 80%) !important;
    z-index: 2;

    &.prismatic-hex {
      z-index: 1;
    }
  }

  svg:last-child,
  img:last-child {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  & > img:first-child[type] {
    position: relative;
    display: block;
    z-index: 1;
  }

  .countLabel {
    position: absolute;
    bottom: calc(var(--sp-1) * -1);
    right: calc(var(--sp-3) * -1);
    border-radius: var(--br);
    z-index: 2;
    background: var(--shade7);
    padding: 0 0.15rem;
  }
`;
